import React from 'react';

const EventHistoryModal = ({ show, events, emailSubject, onClose }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  const getEventIcon = (eventType) => {
    const icons = {
      delivery: 'fas fa-check-circle',
      bounce: 'fas fa-exclamation-triangle',
      open: 'fas fa-envelope-open',
      click: 'fas fa-mouse-pointer',
      spam: 'fas fa-ban',
      unsubscribe: 'fas fa-user-times',
      reject: 'fas fa-times-circle'
    };
    return icons[eventType] || 'fas fa-info-circle';
  };

  const getEventColor = (eventType) => {
    const colors = {
      delivery: '#28a745',
      bounce: '#dc3545',
      open: '#007bff',
      click: '#6f42c1',
      spam: '#fd7e14',
      unsubscribe: '#6c757d',
      reject: '#dc3545'
    };
    return colors[eventType] || '#6c757d';
  };

  const getEventDescription = (eventType) => {
    const descriptions = {
      delivery: 'Email was successfully delivered to the recipient\'s inbox',
      bounce: 'Email bounced back and could not be delivered',
      open: 'Recipient opened the email',
      click: 'Recipient clicked a link in the email',
      spam: 'Email was marked as spam by the recipient',
      unsubscribe: 'Recipient unsubscribed from emails',
      reject: 'Email was rejected by the recipient\'s server'
    };
    return descriptions[eventType] || 'Email event occurred';
  };

  if (!show) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      backdropFilter: 'blur(4px)'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '16px',
        width: '90%',
        maxWidth: '800px',
        maxHeight: '85vh',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.2)',
        border: '1px solid #e9ecef',
        overflow: 'hidden'
      }}>
        {/* Header */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          padding: '24px 28px',
          background: 'linear-gradient(135deg, #059669 0%, #0d9488 100%)',
          color: 'white'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '12px',
              backgroundColor: 'rgba(255,255,255,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <i className="fas fa-history" style={{ fontSize: '18px' }}></i>
            </div>
            <div>
              <h3 style={{ margin: '0 0 4px 0', fontSize: '20px', fontWeight: '600' }}>Email Delivery Events</h3>
              <p style={{ margin: 0, fontSize: '14px', opacity: 0.9, maxWidth: '400px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {emailSubject}
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'rgba(255,255,255,0.2)',
              border: 'none',
              borderRadius: '8px',
              color: 'white',
              cursor: 'pointer',
              padding: '8px',
              width: '36px',
              height: '36px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '18px',
              transition: 'all 0.2s ease'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.3)'}
            onMouseOut={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.2)'}
          >
            <i className="fas fa-times"></i>
          </button>
        </div>

        {/* Content */}
        <div style={{ flex: 1, overflow: 'auto', padding: '28px', backgroundColor: '#fafbfc' }}>
          {!events || events.length === 0 ? (
            <div style={{ 
              textAlign: 'center', 
              padding: '60px 40px', 
              backgroundColor: 'white',
              borderRadius: '12px',
              border: '1px solid #e9ecef'
            }}>
              <i className="fas fa-calendar-times" style={{ fontSize: '48px', marginBottom: '16px', color: '#dee2e6' }}></i>
              <h5 style={{ margin: '0 0 8px 0', color: '#495057' }}>No Events Recorded</h5>
              <p style={{ margin: 0, color: '#6c757d' }}>No delivery events have been recorded for this email yet.</p>
            </div>
          ) : (
            <div>
              {/* Event Statistics */}
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', 
                gap: '16px', 
                marginBottom: '28px' 
              }}>
                <div style={{ 
                  padding: '20px', 
                  backgroundColor: 'white', 
                  borderRadius: '12px', 
                  textAlign: 'center',
                  border: '1px solid #e9ecef',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.04)',
                  transition: 'transform 0.2s ease'
                }}
                onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
                onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                >
                  <div style={{ fontSize: '28px', fontWeight: '700', color: '#007bff', marginBottom: '8px' }}>
                    {events.length}
                  </div>
                  <div style={{ fontSize: '13px', color: '#6c757d', fontWeight: '500' }}>Total Events</div>
                </div>
                <div style={{ 
                  padding: '20px', 
                  backgroundColor: 'white', 
                  borderRadius: '12px', 
                  textAlign: 'center',
                  border: '1px solid #e9ecef',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.04)',
                  transition: 'transform 0.2s ease'
                }}
                onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
                onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                >
                  <div style={{ fontSize: '28px', fontWeight: '700', color: '#28a745', marginBottom: '8px' }}>
                    {new Set(events.map(e => e.event)).size}
                  </div>
                  <div style={{ fontSize: '13px', color: '#6c757d', fontWeight: '500' }}>Event Types</div>
                </div>
                <div style={{ 
                  padding: '20px', 
                  backgroundColor: 'white', 
                  borderRadius: '12px', 
                  textAlign: 'center',
                  border: '1px solid #e9ecef',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.04)',
                  transition: 'transform 0.2s ease'
                }}
                onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
                onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                >
                  <div style={{ fontSize: '28px', fontWeight: '700', color: '#6f42c1', marginBottom: '8px' }}>
                    {Math.round((Date.now() - new Date(events[0]?.timestamp).getTime()) / (1000 * 60 * 60))}h
                  </div>
                  <div style={{ fontSize: '13px', color: '#6c757d', fontWeight: '500' }}>Since First Event</div>
                </div>
              </div>

              {/* Event Timeline */}
              <div style={{ 
                backgroundColor: 'white',
                padding: '24px',
                borderRadius: '12px',
                border: '1px solid #e9ecef',
                boxShadow: '0 2px 4px rgba(0,0,0,0.04)',
                position: 'relative'
              }}>
                <h5 style={{ 
                  marginBottom: '24px', 
                  color: '#212529',
                  fontSize: '18px',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  <i className="fas fa-timeline" style={{ color: '#007bff' }}></i>
                  Event Timeline
                </h5>
                
                {/* Timeline line */}
                <div style={{
                  position: 'absolute',
                  left: '44px',
                  top: '80px',
                  bottom: '24px',
                  width: '3px',
                  background: 'linear-gradient(to bottom, #007bff, #e9ecef)',
                  borderRadius: '2px'
                }}></div>

                {events.map((event, index) => (
                  <div key={index} style={{ 
                    display: 'flex', 
                    alignItems: 'flex-start', 
                    marginBottom: '24px',
                    position: 'relative',
                    paddingLeft: '8px'
                  }}>
                    {/* Timeline dot */}
                    <div style={{
                      width: '48px',
                      height: '48px',
                      borderRadius: '50%',
                      backgroundColor: getEventColor(event.event),
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '20px',
                      zIndex: 1,
                      position: 'relative',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                      border: '3px solid white'
                    }}>
                      <i className={getEventIcon(event.event)} style={{ color: 'white', fontSize: '16px' }}></i>
                    </div>

                    {/* Event details */}
                    <div style={{ 
                      flex: 1, 
                      paddingTop: '4px',
                      backgroundColor: '#f8f9fa',
                      padding: '16px',
                      borderRadius: '12px',
                      border: '1px solid #e9ecef'
                    }}>
                      <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'flex-start',
                        marginBottom: '8px'
                      }}>
                        <h6 style={{ 
                          margin: 0, 
                          color: '#212529',
                          textTransform: 'capitalize',
                          fontSize: '18px',
                          fontWeight: '600'
                        }}>
                          {event.event}
                        </h6>
                        <span style={{ 
                          fontSize: '13px', 
                          color: '#6c757d',
                          whiteSpace: 'nowrap',
                          marginLeft: '16px',
                          fontWeight: '500'
                        }}>
                          {formatDate(event.timestamp)}
                        </span>
                      </div>
                      
                      <p style={{ 
                        margin: '0 0 12px 0', 
                        fontSize: '14px', 
                        color: '#495057',
                        lineHeight: '1.5'
                      }}>
                        {getEventDescription(event.event)}
                      </p>

                      {/* Event metadata */}
                      <div style={{ 
                        fontSize: '12px', 
                        color: '#6c757d',
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                        gap: '8px',
                        marginBottom: '12px'
                      }}>
                        <div style={{
                          padding: '6px 10px',
                          backgroundColor: 'white',
                          borderRadius: '6px',
                          border: '1px solid #e9ecef'
                        }}>
                          <strong>Event ID:</strong> {event.eventId}
                        </div>
                        {event.sendingDomain && (
                          <div style={{
                            padding: '6px 10px',
                            backgroundColor: 'white',
                            borderRadius: '6px',
                            border: '1px solid #e9ecef'
                          }}>
                            <strong>Domain:</strong> {event.sendingDomain}
                          </div>
                        )}
                        {event.sendingStream && (
                          <div style={{
                            padding: '6px 10px',
                            backgroundColor: 'white',
                            borderRadius: '6px',
                            border: '1px solid #e9ecef'
                          }}>
                            <strong>Stream:</strong> {event.sendingStream}
                          </div>
                        )}
                      </div>

                      {/* Custom variables */}
                      {event.customVariables && Object.keys(event.customVariables).length > 0 && (
                        <div style={{ 
                          marginTop: '12px',
                          padding: '12px',
                          backgroundColor: 'white',
                          borderRadius: '8px',
                          fontSize: '12px',
                          border: '1px solid #e9ecef'
                        }}>
                          <div style={{ 
                            fontWeight: '600', 
                            marginBottom: '8px',
                            color: '#495057',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px'
                          }}>
                            <i className="fas fa-tags" style={{ color: '#007bff' }}></i>
                            Custom Variables:
                          </div>
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                            {Object.entries(event.customVariables).map(([key, value]) => (
                              <span key={key} style={{ 
                                display: 'inline-block',
                                padding: '4px 8px',
                                backgroundColor: '#e3f2fd',
                                color: '#1976d2',
                                borderRadius: '12px',
                                fontSize: '11px',
                                fontWeight: '500',
                                border: '1px solid #bbdefb'
                              }}>
                                {key}: {String(value)}
                              </span>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{ 
          padding: '20px 28px', 
          borderTop: '1px solid #f1f3f4',
          backgroundColor: '#fafbfc',
          display: 'flex',
          justifyContent: 'flex-end'
        }}>
          <button
            onClick={onClose}
            style={{
              padding: '12px 24px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              transition: 'all 0.2s ease',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#5a6268'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#6c757d'}
          >
            <i className="fas fa-times"></i>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default EventHistoryModal;